import PropTypes from 'prop-types';
import Chart, { useChart } from '../chart';
import { metaFor } from './measurementMeta';

export default function ReadingsChart({ readings, measurement }) {
  const meta = metaFor(measurement);
  const data = (readings || [])
    .filter((r) => r[measurement] !== undefined && r[measurement] !== null)
    .map((r) => [r.t, r[measurement]]);

  const options = useChart({
    chart: { id: 'readings' },
    xaxis: { type: 'datetime' },
    yaxis: { title: { text: meta.unit } },
    stroke: { width: 2, curve: 'smooth' },
    tooltip: { x: { format: 'HH:mm' } },
    legend: { show: false },
  });

  const series = [{ name: meta.label, data }];

  return <Chart type="line" series={series} options={options} height={320} />;
}

ReadingsChart.propTypes = {
  readings: PropTypes.array,
  measurement: PropTypes.string.isRequired,
};
